import { render } from "./Banner.vue?vue&type=template&id=ab49c242&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=ab49c242&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Make_your_burger/Make_your_burger/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab49c242"]])

export default __exports__